import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "14",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#ED0006",
    d: "M11.179 11.83a6.802 6.802 0 0 1-4.398 1.6c-3.745 0-6.781-3-6.781-6.7S3.036.03 6.78.03c1.679 0 3.215.602 4.399 1.6a6.802 6.802 0 0 1 4.398-1.6c3.745 0 6.781 3 6.781 6.7s-3.036 6.7-6.78 6.7a6.802 6.802 0 0 1-4.399-1.6Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#F9A000",
    d: "M11.179 11.83a6.653 6.653 0 0 0 2.382-5.1c0-2.042-.924-3.87-2.382-5.1a6.802 6.802 0 0 1 4.398-1.6c3.745 0 6.78 3 6.78 6.7s-3.035 6.7-6.78 6.7a6.802 6.802 0 0 1-4.398-1.6Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#FF5E00",
    d: "M11.179 11.83a6.653 6.653 0 0 0 2.382-5.1c0-2.042-.924-3.87-2.382-5.1a6.653 6.653 0 0 0-2.382 5.1c0 2.042.924 3.87 2.382 5.1Z"
  })
], -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }